import React from 'react';
import StudioComponent from '../components/studio/studio.component';
import LoadingComponent from '../components/intro/loading.component';
import IntroComponent from '../components/intro/intro.component';

import IsPortrait from '../components/helpers/WindowOrientation';

import { CarsData } from "../data/cars.data";

const ShowroomPage: React.FC = () => {
  
  const isPortrait = IsPortrait();
  const [progress, setProgress] = React.useState(0);
  //First Menu
  //const [introLoaded, setIntroLoaded] = React.useState(false);
  //const [showIntro, setShowIntro] = React.useState(true);
  //const [showCarousel, setShowCarousel] = React.useState(false);

  //Second Menu
  const [studioLoaded, setStudioLoaded] = React.useState(false);
  const [showLoading, setShowLoading] = React.useState(true);
  const [showStudio, setShowStudio] = React.useState(false);

  //Others
  const [showIntro, setShowIntro] = React.useState(false);

  const [selectedCar, setSelectedCar] = React.useState<any>(null);
  const [isTouchScreen, setTouchScreen] = React.useState(false);
  const [audioMute, setAudioMute] = React.useState(false);
  const [isOnARMode, setOnARMode] = React.useState(false);
  const [isARSupported, setARSupported] = React.useState(false);

  React.useEffect(() => {//solo de prueba
    const carsData: any = CarsData();
    setSelectedCar(carsData[0]);
  }, []);

  React.useEffect(() => {
    if(studioLoaded){
      setTimeout(() => { 
        setShowLoading(false);
        setShowIntro(true);
      }, 1000)};    
  }, [studioLoaded]);

  const ShowStudio = () => {
    setShowIntro(false);
    setShowStudio(true);
  }

  const returnToShowroom = () => {
    setSelectedCar(null);
    setShowLoading(false);
    setShowStudio(false)
    setProgress(0);
    setStudioLoaded(false);
  };

  const enableTouchScreen = () => {
    setTouchScreen(true);
  };

  const SelectNewCar = (car: any) => {
  };

  return (
    <div className={`container-app`}>

      {/* <CarouselComponent isPortrait={isPortrait} showCarousel={showCarousel} introLoaded={introLoaded} setSelectedCar={setSelectedCarCarousel} setProgress={setProgress} setIntroLoaded={setIntroLoaded} enableTouchScreen={enableTouchScreen}/> */}

      <StudioComponent car={selectedCar} showStudio={showStudio} audioMute={audioMute} isOnARMode={isOnARMode} isARSupported={isARSupported} isTouchScreen={isTouchScreen}
                       returnToShowroom={returnToShowroom} SelectNewCar={SelectNewCar} setAudioMute={setAudioMute} setOnARMode={setOnARMode} setARSupported={setARSupported} setProgress={setProgress} loaded={studioLoaded} setLoaded={setStudioLoaded}/>

      <IntroComponent isPortrait={isPortrait} showIntro={showIntro} ShowStudio={ShowStudio} enableTouchScreen={enableTouchScreen}/>

      <LoadingComponent isPortrait={isPortrait} progress={progress} showLoading={showLoading} studioLoaded={studioLoaded}/>
    </div>
  );
};

export default ShowroomPage;